import { Endpoint } from './end-point';
import { apiBaseUrl } from './config';

export const APIConstant = {
  // Auth
  logIn: `${apiBaseUrl}${Endpoint.logIn}`,

  // Questions & Interviews
  getReports:           `${apiBaseUrl}${Endpoint.getReports}`,
  getInterviewQuestion: `${apiBaseUrl}${Endpoint.getInterviewQuestion}`,
  getInterviews:        `${apiBaseUrl}${Endpoint.getInterviews}`,
  scheduleInterview:    `${apiBaseUrl}${Endpoint.scheduleInterview}`,
  interviewUpdate:      `${apiBaseUrl}${Endpoint.interviewUpdate}`,
  validateAnswer:       `${apiBaseUrl}${Endpoint.validateAnswer}`,
  analyze:              `${apiBaseUrl}${Endpoint.analyze}`,

  // eKYC
  kycFaceMatch:  `${apiBaseUrl}${Endpoint.face_match}`,
  kycOCR:        `${apiBaseUrl}${Endpoint.ocr}`,
  kycLiveness:   `${apiBaseUrl}${Endpoint.liveness}`,
  livenessVideo: `${apiBaseUrl}${Endpoint.livenessVideo}`,
  detectIdCard:  `${apiBaseUrl}${Endpoint.detectIdCard}`,
  faceMatch:     `${apiBaseUrl}${Endpoint.faceMatch}`,

  // Technology & Users
  getTechnologies: `${apiBaseUrl}${Endpoint.getTechnologies}`,
  getUsers:        `${apiBaseUrl}${Endpoint.getUsers}`,
  users:           `${apiBaseUrl}${Endpoint.users}`,

  // Employee Management
  departments:   `${apiBaseUrl}${Endpoint.departments}`,
  designations:  `${apiBaseUrl}${Endpoint.designations}`,
  employees:     `${apiBaseUrl}${Endpoint.employees}`,
  employeeStats: `${apiBaseUrl}${Endpoint.employeeStats}`,
  onboarding:    `${apiBaseUrl}${Endpoint.onboarding}`,

  // Attendance & Leave
  attendance:       `${apiBaseUrl}${Endpoint.attendance}`,
  attendanceToday:  `${apiBaseUrl}${Endpoint.attendanceToday}`,
  attendanceStats:  `${apiBaseUrl}${Endpoint.attendanceStats}`,
  leaveTypes:       `${apiBaseUrl}${Endpoint.leaveTypes}`,
  leaveRequests:    `${apiBaseUrl}${Endpoint.leaveRequests}`,
  leaveBalances:    `${apiBaseUrl}${Endpoint.leaveBalances}`,
  holidays:         `${apiBaseUrl}${Endpoint.holidays}`,
  upcomingHolidays: `${apiBaseUrl}${Endpoint.upcomingHolidays}`,

  // Payroll
  salaryStructures: `${apiBaseUrl}${Endpoint.salaryStructures}`,
  salaryComponents: `${apiBaseUrl}${Endpoint.salaryComponents}`,
  salaryAssign:     `${apiBaseUrl}${Endpoint.salaryAssign}`,
  salaryAssignments:`${apiBaseUrl}${Endpoint.salaryAssignments}`,
  payrollRuns:      `${apiBaseUrl}${Endpoint.payrollRuns}`,
  payrollStats:     `${apiBaseUrl}${Endpoint.payrollStats}`,
  payslips:         `${apiBaseUrl}${Endpoint.payslips}`,
  taxDeclarations:  `${apiBaseUrl}${Endpoint.taxDeclarations}`,
  taxCompute:       `${apiBaseUrl}${Endpoint.taxCompute}`,
  taxDeclare:       `${apiBaseUrl}${Endpoint.taxDeclare}`,
  // Asset Inventory
  assets:     `${apiBaseUrl}${Endpoint.assets}`,
  assetStats: `${apiBaseUrl}${Endpoint.assetStats}`,
};